// extracted by mini-css-extract-plugin
export default {"ring":"kb_sqrYncy5rPAeUToQT","lds-ring":"JZRLf8p7mDXyBQv8Y1Fy"};